!function() {
    "use strict";

    let targetSelector = "[data-mixitup-target='material']";
    let grid = document.querySelectorAll("[material-filter-grid]"),
        filterGrid;
    let loadMoreElMix = document.querySelector(".load-more-material-button");
    let currentLimit = 6;
    if ($("[material-filter-grid][data-mixitup-current]") !== "" || $("[material-filter-grid][data-mixitup-current]") !== null ) {
        currentLimit = $("[material-filter-grid][data-mixitup-current]").data("mixitup-current");
    };
    const demiLimiter = Math.round(currentLimit/2);

    // Obtiens le filtre de l'url (ex: ...fr/blog#methodes --> methodes)
    function getSelectorFromHash() {
        var hash = window.location.hash.replace(/^#/g, "");//[data-type~='nacelle_articulee']
        var dataName = window.location.pathname === "/occasions" ? "data-categorie" : window.location.pathname === "/admin/publications/materiels" ? "" : "data-type";
        var selector = hash !== "" ? `[${dataName}~='${hash}']` : "[data-mixitup-target='material']";
        // cocher la checkbox qui correspond au filtre;
        $('[material-filter-grid] fieldset[data-filter-group] input[type="checkbox"]').each( function () {
            if ( $( this ).val() === `[${dataName}~='${hash}']`) {
                $( this ).prop("checked", true);
            }
        });
        console.log("selector", selector)
        return selector;
    };
    
    // Met à jour le hash de l'url en fonction des filtres activés
    function setHash(state) {
        var selector = state.activeFilter.selector;//[data-type~='nacelle_articulee']
        // modifier le selecteur pour etre intégré dans url
        var prettySelector = selector !== "" ? selector.split("='")[1].slice(0, -2) : "";
        var newHash = '#' + prettySelector;

        if (selector === targetSelector && window.location.hash) {
            // Équivalent au filtre "all", supprime le hash
            history.pushState(null, document.title, window.location.pathname); // ou history.replaceState()
            handleMixEnd(state);
        } else if (newHash !== window.location.hash && selector !== targetSelector) {
            // Change le hash
            history.pushState(null, document.title, window.location.pathname + newHash); // ou history.replaceState()
            handleMixEnd(state);
        }
    };

    function handleMixEnd(state) {
        // À la fin de chaque opération, nous devons vérifier si la collection
        // actuelle d'éléments cibles correspondants contient des éléments cachés supplémentaires,
        // et activer ou désactiver le bouton charger plus selon le cas
        if (state.activePagination.limit >= state.totalMatching) {
          // Désactive le boutton
          loadMoreElMix.disabled = true;
        // Si activepagination est inférieu au nombre total d'item
        } else if (loadMoreElMix.disabled) {
          // Active le boutton
          loadMoreElMix.disabled = false;
        }
    };

    const theme = {
        init: () => {
            theme.mixerGrid();
            theme.countDataValues();
            theme.dynamicalToogle();
        },

        mixerGrid: () => {
            if (grid === null) return;
            for (let i = 0; i < grid.length; i++) {
                filterGrid = mixitup(grid[i], {
                    multifilter: {
                        enable: true // enable the multifilter extension for the mixer
                    },
                    selectors: {
                        target: targetSelector
                    },
                    load: {
                        filter: getSelectorFromHash()
                    },
                    // controls: {
                    //     scope: "local"
                    //     // toogleLogic: 'and'
                    // },
                    // Show (shirts OR sweaters) AND (red OR blue) AND large
                    // '.shirt.red.large, .shirt.blue.large, .sweater.red.large, .sweater.blue.large'
                    classNames: {
                        block: "",
                        elementFilter: "",
                        elementSort: "",
                        modifierActive: "active"
                    },
                    animation: {
                        duration: 350
                    },
                    pagination: {
                        limit: currentLimit
                    },
                    callbacks: {
                        onMixEnd: setHash
                    }
                });
            };

            // Quand le hash change, actualise le filtre
            window.onhashchange = function() {
                var selector = getSelectorFromHash();

                if (selector !== filterGrid.getState().activeFilter.selector ) {
                    filterGrid.filter(selector)
                };
            };
            // quand la page a fini de charger, active/désactive le bouton et ces écouteurs d'évènements
            document.addEventListener('DOMContentLoaded', function () {
                // Actualise l'état du boutton activé/désactivé (répété en dessou dans fonction click)

                // Si loadMoreElMix
                if (loadMoreElMix) {
                    // Actualise l'état du boutton activé/désactivé
                    var state = filterGrid.getState();
                    handleMixEnd(state);

                    // Ajoute les écouteurs d'évènement au boutton load more
                    loadMoreElMix.addEventListener('click', function() {
                        currentLimit += demiLimiter;
                        // met à jour la grille
                        filterGrid.paginate({
                            limit: currentLimit
                        });

                        // Actualise l'état du boutton activé/désactivé
                        if (currentLimit >= filterGrid.getState().totalMatching) {
                            loadMoreElMix.disabled = true;
                        } else if (loadMoreElMix.disabled) {
                            loadMoreElMix.disabled = false;
                        };
                    });
                }
            });
        },

        // count the number of item whith this categorie
        countDataValues: () => {
            $("fieldset[data-filter-group] input").each(function( index ) {//[data-status~='publie']
                var selector = $( this ).val().split("-").slice(1).join("-").split("~='")[0];
                var value = $( this ).val().split("~='").slice(1).join(" ").slice(0, -2);
                const number = $("[material-filter-grid]").find(`[data-mixitup-target="material"][data-${selector}='${value}']`).length;
                //aller mettre number dans la valeur du badge
                $(this).closest('label').children('.badge').html(number);
              });
        },

        // change the text of the toogle buuton when selected is change
        dynamicalToogle: () => {
            $(".dropdown[data-es-toogle='dynamical'] li span").on("click", function () {
                $(".dropdown[data-es-toogle='dynamical'] .dropdown-toggle span").text($(this).text());
                // $(".dropdown[data-es-toogle='dynamical'] .dropdown-toggle:first-child").val($(this).text());

            });

        }
    };

    theme.init()
}(jQuery);
